<template>
    <div>

    <Cbarra>
        <template slot="slotTitle">Igualdad de Género</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <router-link :to="{name:'igualdad'}">Igualdad de Género</router-link>
        </template>
    </Cbarra>

    <section class="container justify-content-center">
        <div class="bg-principal">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 shadow_principal">
                    <div class="nav flex-column nav-pills bolt mt-4 mb-5" id="v-pills-tab" role="tablist"
                        aria-orientation="vertical">
                        <a class="nav-link active" id="v-pills-01-tab" data-toggle="pill" href="#v-pills-01" role="tab"
                            aria-controls="v-pills-01" aria-selected="true">
                            Introducción
                        </a>
                        <a class="nav-link" id="v-pills-02-tab" data-toggle="pill" href="#v-pills-02" role="tab"
                            aria-controls="v-pills-02" aria-selected="false">
                            Comisión Interna de Equidad de Género del Campus Yucatán
                        </a>
                        <a class="nav-link" id="v-pills-03-tab" data-toggle="pill" href="#v-pills-03" role="tab"
                            aria-controls="v-pills-03" aria-selected="false">
                            Integrantes
                        </a>
                        <a class="nav-link" id="v-pills-04-tab" data-toggle="pill" href="#v-pills-04" role="tab"
                            aria-controls="v-pills-04" aria-selected="false">
                            Ligas de interés
                        </a>
                        <a class="nav-link" id="v-pills-05-tab" data-toggle="pill" href="#v-pills-05" role="tab"
                            aria-controls="v-pills-05" aria-selected="false">
                            Infografías
                        </a>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
                    <div class="tab-content mt-4 mb-5" id="v-pills-tabContent">

                        <div class="tab-pane fade show active" id="v-pills-01" role="tabpanel" aria-labelledby="v-pills-01-tab">
                            <div  v-for="(lista,key) in objTab1.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                            </div>
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->
                        </div>

                        <div class="tab-pane fade" id="v-pills-02" role="tabpanel" aria-labelledby="v-pills-02-tab">
                            <div  v-for="(lista,key) in objTab2.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                            </div>
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->
                        </div>

                        <div class="tab-pane fade" id="v-pills-03" role="tabpanel" aria-labelledby="v-pills-03-tab">
                            <div  v-for="(lista,key) in objTab3.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                            </div>
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>

                        <div class="tab-pane fade" id="v-pills-04" role="tabpanel" aria-labelledby="v-pills-04-tab">
                            <div  v-for="(lista,key) in objTab4.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                            </div>
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01"> 
                            </div><!--fin de la seccion-->
                        </div>

                        <div class="tab-pane fade gallery" id="v-pills-05" role="tabpanel" aria-labelledby="v-pills-05-tab">
                            <div  v-for="(lista,key) in objTab5.ListaDet" :key="key">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="row" v-for="(item,key2) in lista.detalle" :key="key2">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                
                                                <CTexto v-if="(item.TipoTema == 'TEXTO')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTexto>

                                                <CCarrusel v-if="(item.TipoTema == 'IMAGEN')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :Tipo="1" :index="key2"></CCarrusel>
                                                
                                                <CEnlaces v-if="(item.TipoTema == 'ENLACES')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CEnlaces>

                                                <CAcordeon v-if="(item.TipoTema == 'ACORDEON')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos"></CAcordeon>
                                                
                                                <CTabla v-if="(item.TipoTema == 'TABLA')" :value="item" :RutaFile="RutaFile" :listIconos="listIconos" :index="key2"></CTabla>

                                                <CDirectorio v-if="(item.TipoTema == 'DIRECTORIO')" :value="item" :RutaFile="RutaFileD" :listIconos="listIconos" :Tipo="1"></CDirectorio>

                                            </div>
                                        </div><!--fin del tema-->
                                    </div>
                                <hr v-if="lista.Separador == 'SI'" class="divider-01">
                            </div><!--fin de la seccion-->
                        </div>

                        
                    </div>
                </div>
            </div>
        </div>
    </section>

  </div>
</template>
<script>
 import { LightGallery } from 'vue-light-gallery';

export default {
    components: {
      LightGallery,
    },
    data() {
        return {
        images: [
          {  url: 'http://localhost/enes/assets/files/archivos_tema/021_20210215095109.jpg' },
          {  url: 'http://localhost/enes/assets/files/archivos_tema/03_20210215095211.jpg' },
        ],
        index: null,
            urlApi:"inicio/investigacion",
            ListaContenido:[],
            oferta:{},
            Segurity:{},
            ConfCatalogo:{
				title:'Igualdadgenero',
				isModal: true,
				obj: {}
            },
            ConfFiltro:{
				placeHSearch:'Puesto',
				valueSearch:'',
				entrada:25,
				pag:1,
				totalItems:0,
				pageSize:0,
            },
            ConfAcciones:{
            },
            ConfigBtnModal2:{
                emitAdd: 'NuevoModal2',
                emitDel: 'EliminarDetalle'
            },
            configBtnContactos:{
                emitAdd: 'FormContactos',
                emitDel: 'DeleteContactos',
            },
			ConfModal: {
				ShowPie: true,
                Size:'md',
            },
            oBoton1:{
                NameOk:'Crear',
                ShowPie:true,
            },
            oModal2:{
                Titulo: 'Detalles del Tema',
                Size:'lg',
            },
            oBoton2:{
                TipoModal:2,
                ShowPie:true,
            },
            objTema1:{
                editar:false,
                Apartado: 'IGUALDADINTRO',
                Realiza: 'AddTema'
            },
            objTab1:{
                editar:false,
                Apartado: 'IGUALDADINTRO',
                ListaDet: [],
            },

            objTema2:{
                editar:false,
                Apartado: 'IGUALDADCOMiSIONINT',
                Realiza: 'AddTema'
            },
            objTab2:{
                editar:false,
                Apartado: 'IGUALDADCOMiSIONINT',
                ListaDet: [],
            },

            objTema3:{
                editar:false,
                Apartado: 'IGUALDADINTEGRANTES',
                Realiza: 'AddTema'
            },
            objTab3:{
                editar:false,
                Apartado: 'IGUALDADINTEGRANTES',
                ListaDet: [],
            },

            objTema4:{
                editar:false,
                Apartado: 'IGUALDADLIGAINTERES',
                Realiza: 'AddTema'
            },
            objTab4:{
                editar:false,
                Apartado: 'IGUALDADLIGAINTERES',
                ListaDet: [],
            },

            objTema5:{
                editar:false,
                Apartado: 'IGUALDADINFOGRAFIA',
                Realiza: 'AddTema'
            },
            objTab5:{
                editar:false,
                Apartado: 'IGUALDADINFOGRAFIA',
                ListaDet: [],
            },

            RutaFile: '',
            RutaFileD: '',
            listIconos: [],
        }
    },methods: {
         init() {
        // window.baguetteBox.show(0, gallery[0]);
            this.$root.$on('startCarousel', i => {
                let gallery = window.baguetteBox.run('.gallery', {
                overlayBackgroundColor: 'hsl(171, 100%, 41%)'
                });

                window.baguetteBox.show(i, gallery[0]);
        });
         },
      
        async Lista()
        {
            await this.$http.get(this.urlApi, {
					params:{Seccion:'IGUALDADGENERO',TxtBusqueda:'',Entrada:'',pag:'',RegEstatus: 'A',Orden:'SI'}
                }
            ).then((res) => {
				/*this.ConfFiltro.pag			= res.data.pagination.CurrentPage;
				this.ConfFiltro.totalItems 	= res.data.pagination.TotalItems;
				this.ConfFiltro.pageSize	= res.data.pagination.PageSize;
                this.Segurity				= res.data.segurity;*/
                this.RutaFile               = res.data.RutaFile;
                this.RutaFileD              = res.data.RutaFileD;
                this.listIconos             = res.data.listIconos;
                
                let newObj1 = [];
                let newObj2 = [];
                let newObj3 = [];
                let newObj4 = [];
                let newObj5 = [];

               
                $.each(res.data.tema, function(key, value)
                {
                    if(value.Apartado == 'IGUALDADINTRO'){
                        newObj1.push(value)
                    }
                    else if(value.Apartado == 'IGUALDADCOMiSIONINT'){
                        newObj2.push(value)
                    } 
                    else if(value.Apartado == 'IGUALDADINTEGRANTES'){
                        newObj3.push(value)
                    }                     
                    else if(value.Apartado == 'IGUALDADLIGAINTERES'){
                        newObj4.push(value)
                    }  
                    else if(value.Apartado == 'IGUALDADINFOGRAFIA'){
                        newObj5.push(value)
                    }  
                });
                if(newObj1.length > 0){
                    this.objTab1.editar = true;
                    this.objTab1.ListaDet = newObj1;
                }
                if(newObj2.length > 0){
                    this.objTab2.editar = true;
                    this.objTab2.ListaDet = newObj2;
                }
                if(newObj3.length > 0){
                    this.objTab3.editar = true;
                    this.objTab3.ListaDet = newObj3;
                }
                if(newObj4.length > 0){
                    this.objTab4.editar = true;
                    this.objTab4.ListaDet = newObj4;
                }
                if(newObj5.length > 0){
                    this.objTab5.editar = true;
                    this.objTab5.ListaDet = newObj5;;
                }
            });
        },
        iconoFiltrado(buscar)
        {
            let aBuscar = buscar;
            let devuelve = '';
            let arr = this.listIconos.filter(function(vl){
                if(aBuscar!=''){
                    if(aBuscar == vl.Id){
                        return vl;
                    }
                    else{
                        return '';
                    }
                }
            });

            if(arr[0]){
                devuelve = arr[0].Icono;
            }
            
            return devuelve;
        },
    },mounted() {
        window.scrollTo(0, 0);
        this.Lista();
    },
}
</script>